// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%2214%22%20height%3D%2211%22%20viewBox%3D%220%200%2014%2011%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%0A%20%20%20%20%3Cpolygon%20fill%3D%22%23fff%22%20points%3D%2212%201%205%207.5%202%205%201%205.5%205%2010%2013%201.5%22%2F%3E%0D%0A%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FWrw1vxtyi {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.FWrw1vxtyi h4 {
  line-height: 3em;
}
.FWrw1vxtyi .eFdo4ko3N6 {
  float: left;
  width: 100%;
}
.FWrw1vxtyi .a2JPXUCFl4 {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.FWrw1vxtyi .a2JPXUCFl4:hover {
  cursor: pointer;
}
.FWrw1vxtyi .a2JPXUCFl4:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.q7DNYvDbX0 .kPwUJUBgfE:focus {
  outline: none;
}
.q7DNYvDbX0 .kPwUJUBgfE.u05DvLCv6w.FmVLlvDfK7 {
  background: #375A88;
}
.q7DNYvDbX0 .kPwUJUBgfE.u05DvLCv6w.FmVLlvDfK7 span {
  color: #fff;
}
.q7DNYvDbX0 .FmVLlvDfK7 {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.q7DNYvDbX0 .FmVLlvDfK7:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.q7DNYvDbX0 input {
  height: 38px;
  min-width: 220px;
}
.a2JPXUCFl4.oRiktpyYaM {
  background: #410102;
}
.a2JPXUCFl4.E814iOteYW {
  background: #911318;
}
.a2JPXUCFl4.uGyrdHuXi4 {
  background: #D8293B;
}
.a2JPXUCFl4.R7tonf_e_d {
  background: #F2373C;
}
.a2JPXUCFl4.dvi_lLhfdt {
  background: #FC4448;
}
.a2JPXUCFl4.DUTjkoNy7X {
  background: #ED535E;
}
.a2JPXUCFl4.mfVNoxUTU9 {
  background: #E34926;
}
.a2JPXUCFl4.UiI7goP8Lw {
  background: #FC562B;
}
.a2JPXUCFl4.XF5D7tM1io {
  background: #FC6722;
}
.a2JPXUCFl4.kVckOzytiQ {
  background: #FD7F24;
}
.a2JPXUCFl4.wxDrKKLsuO {
  background: #FD8D26;
}
.a2JPXUCFl4.SL59Na4uM7 {
  background: #EC9C3E;
}
.a2JPXUCFl4.iTXBQ_ylOx {
  background: #0e673a;
}
.a2JPXUCFl4.eick0NJaQh {
  background: #208740;
}
.a2JPXUCFl4.lspdUwGSz9 {
  background: #239718;
}
.a2JPXUCFl4.yvT421cwhI {
  background: #55A84D;
}
.a2JPXUCFl4.Ww_1cBblXu {
  background: #4BBE5A;
}
.a2JPXUCFl4.DkOKezu7Pf {
  background: #0CCA6A;
}
.a2JPXUCFl4.cKRg06PHUF {
  background: #0A3C64;
}
.a2JPXUCFl4.YX54p8MH1P {
  background: #0d487a;
}
.a2JPXUCFl4.U4XZH8FiaU {
  background: #10538d;
}
.a2JPXUCFl4.bdBZUDEuuw {
  background: #115A99;
}
.a2JPXUCFl4.s8JEyWyJOy {
  background: #3387E2;
}
.a2JPXUCFl4.ckUaEjSziP {
  background: #1BA9CF;
}
.a2JPXUCFl4.J7hnG2mWlg {
  background: #d27c02;
}
.a2JPXUCFl4.T01gAZBkLj {
  background: #fb9402;
}
.a2JPXUCFl4.K0VKbLK7sw {
  background: #FD9B30;
}
.a2JPXUCFl4.MLrHxEuSxO {
  background: #FDBE2D;
}
.a2JPXUCFl4.VvFLiLpbia {
  background: #FED831;
}
.a2JPXUCFl4.wroyJK5daw {
  background: #FFFD38;
}
.a2JPXUCFl4.LchMG2G4sx {
  background: #2D215C;
}
.a2JPXUCFl4.ev2hgHu7KU {
  background: #483C83;
}
.a2JPXUCFl4.BOdn2DJKwv {
  background: #58518d;
}
.a2JPXUCFl4.DIbVcJ_p4H {
  background: #7068A9;
}
.a2JPXUCFl4.aPSyHIDN1h {
  background: #7f78b2;
}
.a2JPXUCFl4.QNWFSJmtUr {
  background: #8f88bc;
}
.a2JPXUCFl4.RFMDBz7r1j {
  background: #000;
}
.a2JPXUCFl4.evi8f_6rd9 {
  background: #282626;
}
.a2JPXUCFl4.dITK6YVtvO {
  background: #242222;
}
.a2JPXUCFl4.MGAEkaoG8v {
  background: #353838;
}
.a2JPXUCFl4.xm7qaJwIa6 {
  background: #666;
}
.a2JPXUCFl4.Ug8m2NLU0Y {
  background: #999;
}
.HbjK6eVUGo {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.HbjK6eVUGo .URr4mwitpb {
  display: none;
}
.mjqoqJ4CUh {
  border: 1px solid #e5e5e5;
  margin-bottom: 4px;
  margin-top: 8px;
}
.mjqoqJ4CUh .Iv1JWWMG67 {
  display: flex;
  align-items: center;
  height: 70px;
  border-bottom: 1px solid #e5e5e5;
}
.mjqoqJ4CUh .a8EO0W_jHK {
  border-right: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  flex: 5;
  height: 100%;
}
.mjqoqJ4CUh .a8EO0W_jHK > div:first-child {
  flex: 2;
}
.mjqoqJ4CUh .a8EO0W_jHK .wUy5ZRNgQg {
  background-color: #F5F4F9;
  border-radius: 2px;
  margin-left: 12px;
  width: 500px;
}
.mjqoqJ4CUh .a8EO0W_jHK .gnijc5NwZZ {
  border: none;
  flex: 1;
  padding-left: 8px;
}
.mjqoqJ4CUh .Iv1JWWMG67 .Irdfb2X8yL {
  flex: 1;
  text-align: center;
}
.mjqoqJ4CUh .Iv1JWWMG67 .zAkCAuS1eq {
  font-size: 12px;
  margin-bottom: 0;
  text-transform: uppercase;
}
.mjqoqJ4CUh .Iv1JWWMG67 .wrFRoqt0sc {
  font-size: 10px;
  border-bottom: 1px solid #4f5964;
  text-transform: capitalize;
  cursor: pointer;
}
.mjqoqJ4CUh .cAAn_FJFYp .HJIu9TDTUM {
  height: 50px;
  display: flex;
}
.mjqoqJ4CUh .cAAn_FJFYp .HJIu9TDTUM:not(:last-child) {
  border-bottom: 1px solid #e5e5e5;
}
.mjqoqJ4CUh .cAAn_FJFYp .HJIu9TDTUM .sInsTzYF9x {
  display: flex;
  border-right: 1px solid #e5e5e5;
  flex: 5;
}
.mjqoqJ4CUh .cAAn_FJFYp .HJIu9TDTUM .sInsTzYF9x .oQBP1Dcqfu {
  margin-left: 12px;
  display: flex;
  align-items: center;
  flex: 3;
}
.mjqoqJ4CUh .cAAn_FJFYp .HJIu9TDTUM .sInsTzYF9x .oQBP1Dcqfu .HZHGA0cfQx {
  height: 32px;
  width: 32px;
  border-radius: 50%;
}
.mjqoqJ4CUh .cAAn_FJFYp .HJIu9TDTUM .sInsTzYF9x .oQBP1Dcqfu .lMcSBM11zA {
  margin-left: 8px;
}
.mjqoqJ4CUh .cAAn_FJFYp .HJIu9TDTUM .sInsTzYF9x .oQBP1Dcqfu .lMcSBM11zA .jTLHCvSWbQ {
  font-weight: 700;
  font-size: 13px;
}
.mjqoqJ4CUh .cAAn_FJFYp .HJIu9TDTUM .sInsTzYF9x .oQBP1Dcqfu .lMcSBM11zA .Ga2vTlJzPx {
  display: flex;
  font-size: 12px;
  font-style: italic;
}
.mjqoqJ4CUh .cAAn_FJFYp .HJIu9TDTUM .sInsTzYF9x .A7MbNbrVFK {
  flex: 1.5;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}
.mjqoqJ4CUh .cAAn_FJFYp .HJIu9TDTUM .sInsTzYF9x .A7MbNbrVFK .Y3dRzu37ew {
  padding: 0 4px;
  background-color: #e5e5e5;
  font-size: 10px;
  text-transform: uppercase;
  border-radius: 1px;
}
.mjqoqJ4CUh .cAAn_FJFYp .HJIu9TDTUM .RruxD6tx3j {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mjqoqJ4CUh .cAAn_FJFYp .HJIu9TDTUM .RruxD6tx3j:hover {
  cursor: pointer;
  background-color: #FBF0E3;
}
.mjqoqJ4CUh .cAAn_FJFYp .HJIu9TDTUM .EoaWJITw6N {
  background-color: #FBF0E3;
}
.mjqoqJ4CUh .cAAn_FJFYp .HJIu9TDTUM .RruxD6tx3j .TgTp0qgq8Q {
  z-index: 1;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  margin: 0;
  -webkit-appearance: none;
  cursor: pointer;
}
.mjqoqJ4CUh .cAAn_FJFYp .HJIu9TDTUM .RruxD6tx3j .TgTp0qgq8Q:hover {
  background-color: #FBF0E3;
}
.mjqoqJ4CUh .cAAn_FJFYp .HJIu9TDTUM .RruxD6tx3j .TgTp0qgq8Q:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-color: #EAAC6D;
  background-position: 50% 50%;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `FWrw1vxtyi`,
	"color-row": `eFdo4ko3N6`,
	"color-tile": `a2JPXUCFl4`,
	"picker-component": `q7DNYvDbX0`,
	"picker-element": `kPwUJUBgfE`,
	"active": `u05DvLCv6w`,
	"btn": `FmVLlvDfK7`,
	"red-1": `oRiktpyYaM`,
	"red-2": `E814iOteYW`,
	"red-3": `uGyrdHuXi4`,
	"red-4": `R7tonf_e_d`,
	"red-5": `dvi_lLhfdt`,
	"red-6": `DUTjkoNy7X`,
	"orange-1": `mfVNoxUTU9`,
	"orange-2": `UiI7goP8Lw`,
	"orange-3": `XF5D7tM1io`,
	"orange-4": `kVckOzytiQ`,
	"orange-5": `wxDrKKLsuO`,
	"orange-6": `SL59Na4uM7`,
	"green-1": `iTXBQ_ylOx`,
	"green-2": `eick0NJaQh`,
	"green-3": `lspdUwGSz9`,
	"green-4": `yvT421cwhI`,
	"green-5": `Ww_1cBblXu`,
	"green-6": `DkOKezu7Pf`,
	"blue-1": `cKRg06PHUF`,
	"blue-2": `YX54p8MH1P`,
	"blue-3": `U4XZH8FiaU`,
	"blue-4": `bdBZUDEuuw`,
	"blue-5": `s8JEyWyJOy`,
	"blue-6": `ckUaEjSziP`,
	"yellow-1": `J7hnG2mWlg`,
	"yellow-2": `T01gAZBkLj`,
	"yellow-3": `K0VKbLK7sw`,
	"yellow-4": `MLrHxEuSxO`,
	"yellow-5": `VvFLiLpbia`,
	"yellow-6": `wroyJK5daw`,
	"purple-1": `LchMG2G4sx`,
	"purple-2": `ev2hgHu7KU`,
	"purple-3": `BOdn2DJKwv`,
	"purple-4": `DIbVcJ_p4H`,
	"purple-5": `aPSyHIDN1h`,
	"purple-6": `QNWFSJmtUr`,
	"black-1": `RFMDBz7r1j`,
	"black-2": `evi8f_6rd9`,
	"black-3": `dITK6YVtvO`,
	"black-4": `MGAEkaoG8v`,
	"black-5": `xm7qaJwIa6`,
	"black-6": `Ug8m2NLU0Y`,
	"picker-theme": `HbjK6eVUGo`,
	"arrow-regular": `URr4mwitpb`,
	"notification-users-options__root": `mjqoqJ4CUh`,
	"notification-users-options__header": `Iv1JWWMG67`,
	"notification-users-options__header--input": `a8EO0W_jHK`,
	"header-input__root": `wUy5ZRNgQg`,
	"header-input__input": `gnijc5NwZZ`,
	"header__select-option": `Irdfb2X8yL`,
	"header__select-option--label": `zAkCAuS1eq`,
	"header__select-option--all": `wrFRoqt0sc`,
	"notification-users-options__body": `cAAn_FJFYp`,
	"user-option": `HJIu9TDTUM`,
	"user-option__user": `sInsTzYF9x`,
	"user-option__info": `oQBP1Dcqfu`,
	"user-option__avatar": `HZHGA0cfQx`,
	"user-option__text": `lMcSBM11zA`,
	"user-option__name": `jTLHCvSWbQ`,
	"user-option__role": `Ga2vTlJzPx`,
	"user-option__status": `A7MbNbrVFK`,
	"user-option__label": `Y3dRzu37ew`,
	"user-option__selection": `RruxD6tx3j`,
	"user-option__selection--selected": `EoaWJITw6N`,
	"user-option__selection--checkbox": `TgTp0qgq8Q`
};
export default ___CSS_LOADER_EXPORT___;
